<template>
    <div>
        <el-row >
            <el-col v-if="refreshStatus" span="18">
        <el-collapse v-model="activeNames" v-if="paramData.length"  >
        <el-card class="box-card" style="margin-top:20px;">
            <div slot="header" class="clearfix">
                <div style="display:flex;width:400px; position:relative">
                    <div style="font-size:20px;font-weight:bold;min-width:130px;height:40px;line-height:40px">参数配置</div>
                    <el-button  v-if='headerButtonFlag' @click="hearHandle"  style="color:#409EFF;position:absolute;right:-483px;top:10px;padding: 3px 0;border:0">点 击 展 开</el-button>
                </div>
            </div>
             <el-collapse-item :title="paramData.length+'条'" name="paramData">
             <el-table v-if="refreshStatus"
                :data="paramData"
                ref="sssss"
                style="width: 100%">
                <el-table-column
                    prop="paramName"
                    width="200"
                    label="参数名称">
                </el-table-column>

                <el-table-column
                    prop="paramKey"
                    label="参数键名"
                    width="300">
                </el-table-column>
                <el-table-column
                    prop="paramValue"
                    label="参数键值"
                    >
                    <template slot-scope="scope">
                        <span v-if="scope.row.type !=='select'">{{ scope.row.paramValue }}</span>
                        <span v-if="scope.row.type =='select'">{{ tool.getDictionaryValue(scope.row.dictData,'label','value',scope.row.paramValue) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="remark"
                    min-width="150"
                    label="备注">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.show">{{ scope.row.remark }}</span>
                        <el-input v-if="scope.row.show" v-model="scope.row.remark"   placeholder="备注"></el-input>
                    </template>
                </el-table-column>

                <el-table-column
                    label="操作"
                    min-width="100"
                    >
                     <template slot-scope="scope">
                        <el-button
                        size="mini"
                        @click="prejectParamEdit(scope.$index, scope.row)">编 辑</el-button>

                    </template>
                </el-table-column>

            </el-table>
              </el-collapse-item>
        </el-card>
        </el-collapse>
        </el-col>
        </el-row>
        <el-row>
            <el-col v-if="refreshStatus" span="18">
        <el-collapse v-model="activeNames"  v-for='(item,index) in tabledata' :key="item" @change="e=> handleChange(item,index,'change',e)">
        <el-card class="box-card" style="margin-top:20px;">
            <div slot="header" class="clearfix">
                <div style="display:flex;width:400px " >
                    <div style="font-size:20px;font-weight:bold;min-width:130px;height:40px;line-height:40px">{{ item.label }}</div>
                   <!-- <div  v-if="!scope.row.show">{{ scope.row.dictKey }}</div> -->
                    <!-- <el-input style="flex-shrink: 1;" v-model="item.label"  placeholder="key值"></el-input>
                    <el-button style="float: right;margin-left:20px; " size="mini" type="primary"    @click="addDict(item)" >修改参数值</el-button> -->
                </div>

                <el-button style="float: right; padding: 3px 0" type="text" v-if="!item.showButtonAdd" @click="handleChange(item,index,'click')" >点 击 展 开</el-button>
                <el-button style="float: right; padding: 3px 0" type="text" v-if="item.showButtonAdd" @click="addDict(item)" >添 加</el-button>
            </div>
             <el-collapse-item :title="item.value.length+'条'" :name="index">
             <el-table v-if="refreshStatus"
                :data="item.value"
                :ref="item.dictionaryId"
                style="width: 100%">
                <el-table-column
                    prop="sort"
                    width="150"
                    label="字典序号">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.show">{{ scope.row.sort }}</span>
                        <el-input v-if="scope.row.show" v-model="scope.row.sort"   placeholder="序号"></el-input>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="dictValue"
                    label="字典名称"
                    width="180">
                    <template slot-scope="scope">
                        <span>{{ scope.row.dictValue }}</span>
                        <!-- <el-input v-if="scope.row.show" v-model="scope.row.value"   placeholder="value值"></el-input> -->
                    </template>
                </el-table-column>
                <el-table-column
                    prop="dictKey"
                    label="字典键值"
                    width="200">
                    <template slot-scope="scope">
                        <div  v-if="!scope.row.show">{{ scope.row.dictKey }}</div>
                        <el-input v-if="scope.row.show" v-model="scope.row.dictKey"  placeholder="key值"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="remark"
                    min-width="250"
                    label="备注">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.show">{{ scope.row.remark }}</span>
                        <el-input v-if="scope.row.show" v-model="scope.row.remark"   placeholder="备注"></el-input>
                    </template>
                </el-table-column>

                <el-table-column
                    label="操作"
                    min-width="100"
                    >
                     <template slot-scope="scope">
                        <el-button
                        size="mini"
                        v-if="!scope.row.show"
                        @click="handleEdit(scope.$index, scope.row,item)">编辑</el-button>
                         <el-button
                        size="mini"
                        v-if="scope.row.show"
                        @click="handleEdit(scope.$index, scope.row,item)">保存</el-button>
                        <!-- <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, item.value)">删除</el-button> -->
                    </template>
                </el-table-column>

            </el-table>
              </el-collapse-item>
            <el-row >
                <el-col span="18" style="text-align:center">
                     <!-- <el-button type="primary" @click="add">主要按钮</el-button> -->
                    <!-- <el-button class="addButton" size="mini" @click="addDict(item)"> + </el-button> -->
                </el-col>

            </el-row>



        </el-card>
        </el-collapse>
        </el-col>
        </el-row>
        <hr-dialog title="新增字典" :visible.sync="dialogFormVisible" >
            <template slot="body">
                <div style="width:100%" v-if="dialogFormVisible">
            <el-form :model="form" ref="form" v-if="dialogFormVisible" width="200px">
                <el-form-item label="字典序号"  prop="sort"
                :rules="[
                { required: true, message: '字典序号不能为空！', trigger: 'blur' },
                { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入自然数' }
                ]" :label-width="formLabelWidth">
                    <el-input   maxlength="8" show-word-limit v-model="form.sort" placeholder="请输入字典序号" ></el-input>
                </el-form-item>
                 <el-form-item label="字典名称"  prop="dictValue" :rules="[{ required: true, message: '字典名称不能为空！', trigger: 'blur' }]" :label-width="formLabelWidth">
                    <el-input v-model="form.dictValue" :maxlength="dictionaryOption.maxlength" show-word-limit placeholder="请输入字典名称" ></el-input>
                </el-form-item>

                 <el-form-item label="字典键值"  prop="dictKey" :rules="[{ pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入自然数' },{ required: true, message: '字典键值不能为空！', trigger: 'blur' }]" :label-width="formLabelWidth">
                    <el-input v-model.trim="form.dictKey"
                              maxlength="8" show-word-limit  placeholder="请输入字典键值" ></el-input>
                </el-form-item>
                 <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="form.remark" maxlength="30" show-word-limit  placeholder="请输入字典备注" ></el-input>
                </el-form-item>

            </el-form>
            </div>
            </template>
            <template slot="footer" class="dialog-footer" style="margin-right:24px">
                <el-button type="primary" @click="addSubmit" style="padding: 9px 15px; font-size: 12px; border-radius: 3px">
                    <i class="el-icon-circle-plus-outline"></i> <span>保 存</span>
                </el-button>
                <el-button @click="dialogFormVisible = false" style="padding: 9px 15px; font-size: 12px; border-radius: 3px;margin-right:23px;">
                    <i class="el-icon-circle-close"></i> <span>取 消</span>
                </el-button>
            </template>
        </hr-dialog>
         <el-dialog title="修改" :visible.sync="dialogFormVisibleEdit" :modal-append-to-body='false' :close-on-click-modal='false'>
            <div style="width:100%" >
            <el-form :model="form" ref="form" v-if="dialogFormVisibleEdit" width="200px">
                <el-form-item label="字典序号"  prop="sort"
                :rules="[
                { required: true, message: '字典序号不能为空！', trigger: 'blur' },
                { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入自然数' }
                ]" :label-width="formLabelWidth">
                    <el-input maxlength="8" show-word-limit v-model="form.sort"  placeholder="请输入字典序号"></el-input>
                </el-form-item>
                 <el-form-item label="字典名称"  :rules="[{ required: true, message: '字典名称不能为空！', trigger: 'blur' }]" prop="dictValue" :label-width="formLabelWidth">
                    <el-input
                    v-model="form.dictValue"
                    :maxlength=" dictionaryOption.maxlength"
                    show-word-limit

                    placeholder="请输入字典名称"></el-input>
                </el-form-item>
                 <el-form-item label="字典键值"  prop="dictKey" :rules="[{ pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入自然数' },{ required: true, message: '字典键值不能为空！', trigger: 'blur' }]" :label-width="formLabelWidth">
                    <el-input v-model="form.dictKey" disabled maxlength="8" show-word-limit  placeholder="请输入字典键值"></el-input>
                </el-form-item>
                 <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="form.remark" maxlength="30" show-word-limit  placeholder="请输入字典备注"></el-input>
                </el-form-item>

            </el-form>  
            </div>
            <div slot="footer" class="dialog-footer" >
                  <el-button type="primary" @click="update" style="padding: 9px 15px; font-size: 12px; border-radius: 3px">
                    <i class="el-icon-circle-plus-outline"></i> <span>修 改</span>
                </el-button>
                <el-button @click="dialogFormVisibleEdit = false" style="padding: 9px 15px; font-size: 12px; border-radius: 3px">
                    <i class="el-icon-circle-close"></i> <span>取 消</span>
                </el-button>
              
            </div>
        </el-dialog>
         <el-dialog title="修改参数配置" :visible.sync="dialogParamUpdateEdit" :modal-append-to-body='flagIsFalse' :close-on-click-modal='flagIsFalse'>
            <div style="width:100%" >
            <el-form :model="prejectParamForm" ref="prejectParamForm" v-if="dialogParamUpdateEdit" width="200px">
                <el-form-item label="参数名称"  prop="paramName"
                        :label-width="formLabelWidth">
                    <el-input maxlength="8" show-word-limit v-model="prejectParamForm.paramName" disabled  placeholder="请输入参数名称"></el-input>
                </el-form-item>
                 <el-form-item label="参数键名"  :rules="[{ required: true, message: '参数键名不能为空！', trigger: 'blur' }]" prop="paramKey" :label-width="formLabelWidth">
                    <el-input
                    v-model="prejectParamForm.paramKey"
                    maxlength="20"
                    show-word-limit
                    disabled
                    placeholder="请输入参数键名"></el-input>
                </el-form-item>
                 <el-form-item label="参数键值"  prop="paramValue" :rules="paramValueFormOption.rules" :label-width="formLabelWidth">
                    <!-- <el-input v-model="prejectParamForm.paramValue"  maxlength="8" show-word-limit  placeholder="请输入参数键值"></el-input> -->
                    <el-input
                    v-if="paramValueFormOption.type !='select'"
                    :type="paramValueFormOption.type || 'text'"
                    :maxlength="paramValueFormOption.maxlength"
                    show-word-limit

                    v-model="prejectParamForm.paramValue"></el-input>
                    <el-select
                        v-if="paramValueFormOption.type =='select'"
                        v-model="prejectParamForm.paramValue2"
                        @change="paramValueChange"
                        style="width:100%"
                    >
                        <el-option
                            v-for="item in paramValueFormOption.dictData"
                            :key="item"
                            :value="item.value"
                            :label="item.label"
                        >

                        </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="prejectParamForm.remark" maxlength="30" disabled show-word-limit  placeholder="请输入备注"></el-input>
                </el-form-item>

            </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="updateParameter" style="padding: 9px 15px; font-size: 12px; border-radius: 3px">
                    <i class="el-icon-circle-plus-outline"></i> <span>保 存</span>
                </el-button>
                <el-button @click="dialogParamUpdateEdit = false" style="padding: 9px 15px; font-size: 12px; border-radius: 3px">
                    <i class="el-icon-circle-close"></i> <span>取 消</span>
                </el-button>
              
            </div>
        </el-dialog>

    </div>
</template>
<script>
import {
    getMap,
    add,
    update,
    remove,
    updateParameter
} from "@/api/crmedical/project-dictionary/project-dictionary";
// import Vue from "vue";
export default {
    props:['tabledata','projectId','activeName','paramData'],
    data(){
        return{
            headerButtonFlag:true,
            flagIsFalse:false,
            activeNames:'',
            dialogParamUpdateEdit:false,
            refreshStatus:true,
            dialogFormVisibleEdit:false,
            dialogFormVisible: false,
            formLabelWidth:'80px',
            prejectParamForm:{
                paramName:'',
                paramKey:'',
                paramName:'',
                remark:''
            },
            form: {
                sort:'0',
                dictKey:'',
                dictValue:'',
                remark:'',
                id:'',
                code:'',
            },
            // 对不同要求的参数值进行不同的配置
            paramValueFormOption:{
                type:'',
                rules:[],
                maxlength:'',
                showWordLimit:false,
                dictData:[
                    {label:'二维码',value:1}
                ],
            },
            paramValueFormOptionDictData:[],
            // 字典编辑添加 表单配置 默认值
            dictionaryOption:{
                maxlength:20,
            }

        }
    },
    created(){
        console.log(this.paramData)
    },
    watch:{
        'projectId'(){
            this.activeNames=-1;
        },
        'activeName'(){

             this.activeNames=-1;
        }
    },
    methods:{
        hearHandle(){
            this.headerButtonFlag = !this.headerButtonFlag
        },
        //修改参数配置
        updateParameter(){
            this.prejectParamForm.projectId = this.projectId;
            this.prejectParamForm.tabId = this.activeName;
            this,this.$refs.prejectParamForm.validate((valid)=>{
                if(valid){
                    updateParameter(this.prejectParamForm).then(res=>{
                        console.log(res)
                        if(res.msg == "操作成功"){
                            this.$message({
                                message: '修改成功!',
                                type: 'success'
                            });
                            this.dialogParamUpdateEdit = false;
                             this.$emit('getProjectParamList');
                        }else{
                            this.$message.error('添加失败！');
                        }
                    })
                }else{
                    return false;
                }
            })

        },
        // 展开方法或者切换标签
        handleChange(item,index,type,e){
            if(type=="click"){

                item.showButtonAdd = true;
                this.activeNames = index;

            }
            if(type == "change"){
                if(e[0]==index || e[1]==index){
                    item.showButtonAdd = true;
                }else{
                    item.showButtonAdd = false;
                }

            }

        },
        //打开添加字典弹窗
        addDict(item){
            this.dictionaryOption.maxlength = item.maxlength || 50;
            this.dialogFormVisible = true;
            for(var key in this.form){
                if(key=='sort'){
                     this.form[key] = '0';
                }else{
                     this.form[key] = '';
                }
            }
            this.form.code = item.dictionaryId;

        },
        // 添加字典方法
        addSubmit(){

            this.$refs.form.validate((valid) => {

                if (valid) {
                    this.form.projectId = this.projectId;
                   add(this.form).then(res=>{
                       if(res.success){
                           this.$message({
                                message: '添加成功！',
                                type: 'success'
                            });
                            this.$emit('handleClick',this.tabledata);
                            this.dialogFormVisible = false;
                       }else{
                            this.$message.error('添加失败！');
                       }
                   })

                } else {

                    return false;
                }
                });


        },
        // 编辑字典方法
        handleEdit(index,row,item) {
            this.dictionaryOption.maxlength = item.maxlength || 50;
            for(let key in row){
                this.form[key] = row[key];
            }
            this.form.sort = String(this.form.sort)
            this.dialogFormVisibleEdit = true;


      },
    //   当修改参数值为下拉框时选择数据
        paramValueChange(e){
            this.prejectParamForm.paramValue = e;
        },
    //   打开项目字典参数配置弹窗
        prejectParamEdit(index,row){
            this.$set(this.prejectParamForm,'paramName',row.paramName);
            this.$set(this.prejectParamForm,'paramKey',row.paramKey);
            this.$set(this.prejectParamForm,'paramValue',row.paramValue);
            this.$set(this.prejectParamForm,'remark',row.remark);
            this.$set(this.paramValueFormOption,'type',row.type);
            this.$set(this.paramValueFormOption,'rules',row.rules);
            this.$set(this.paramValueFormOption,'maxlength',row.maxlength);
            this.$set(this.paramValueFormOption,'showWordLimit',row.showWordLimit);

            if(row.type=="select"){
                this.$set(this.prejectParamForm,'paramValue2',this.tool.getDictionaryValue(row.dictData,'label','value',row.paramValue));

                this.$set(this.paramValueFormOption,'dictData',row.dictData);
            }
            this.paramValueFormOptionDictData = row.dictData
            console.log(this.paramValueFormOption)
            this.dialogParamUpdateEdit = true;
      },
    //   字典编辑方法
      update(){
           this.$refs.form.validate((valid) => {

                if (valid) {
                    this.form.projectId = this.projectId;
                   update(this.form).then(res=>{
                       if(res.success){
                           this.$message({
                                message: '修改成功！',
                                type: 'success'
                            });
                             this.$emit('handleClick',this.tabledata);
                            this.dialogFormVisibleEdit = false;
                       }else{
                            this.$message.error('修改失败！');
                       }
                   })

                } else {

                    return false;
                }
                });
      },
      handleDelete(index, data) {

        data.splice(index,1);

      }
    }
}
</script>
<style scoped>
.clearfix{
    display: flex;
    justify-content: space-between;
}
td{
    list-style: none;
    min-width: 100px;
    text-align: center;
    display: inline-block;
}
    .item2{
        text-align: center;

    }
    .addButton{
        margin: auto;
        width: 100px;

        border-bottom-left-radius: 50%;
        border-bottom-right-radius: 50%;
        background-color: #fff;
    }
</style>
